import { connect } from "react-redux"
import { useEffect } from "react"
import { Dispatch } from "redux"
import { wsConnect, wsDisconnect } from "./actions"
import { getFlagEnabled } from "../getFlagValue"

type tWebSocketConnectionProps = {
    dispatch: Dispatch
    host?: string
    children: JSX.Element[]
}

const WebSocketConnection = (props: tWebSocketConnectionProps) => {
    const { dispatch, host } = props

    // only connect if we have a host - this makes it easier to control with flags
    if (!getFlagEnabled("WA-8936-rework-react-select-wrapper")) {
        if (host) {
            dispatch(wsConnect(host))
        } else {
            dispatch(wsDisconnect())
        }
    }

    useEffect(() => {
        if (getFlagEnabled("WA-8936-rework-react-select-wrapper")) {
            // only connect if we have a host - this makes it easier to control with flags
            if (host) {
                dispatch(wsConnect(host))
            } else {
                dispatch(wsDisconnect())
            }
        }
    }, [dispatch, host])

    return <div>{props.children}</div>
}

export default connect()(WebSocketConnection)
